// extracted by mini-css-extract-plugin
export default {"userListLetterHeader":"UserListItemsHeader_userListLetterHeader__PXd28"};